import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	breadcrumb: {
		display: "flex",
		alignItems: "center"
	},
	statusLabel: {
		color: colors.gray[700]
	},
	chatTabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	chatTab: {
		color: `${colors.gray[700]} !important`,
		opacity: 1,
		fontSize: 14
	},
	chatTabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	},
	scheduleMesssageButton: {
		color: colors.getPrimaryColor()
	},
	cancelScheduleMesssageButton: {
		color: colors.red[400],
		borderColor: colors.red[400],
		fontWeight: "normal"
	},
	messageBlastTitle: {
		fontWeight: 600,
		wordWrap: "break-word",
		display: "-webkit-box",
		WebkitLineClamp: 2,
		WebkitBoxOrient: "vertical",
		overflow: "hidden",
		textOverflow: "ellipsis"
	}
})

export default useStyles
